module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/50ca829226bea12f7a4bb844bf090ee2.png";